.wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  video {
    width: 90%;
    max-width: 800px;
    max-height: 70vh;
  }

  .options {
    padding: 0 2rem;
    font-size: 1.1rem;
    margin: 1rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }

  .result {
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 1.2rem;
    height: 3rem;
    margin-bottom: 0.5rem;
  }

  :global(.uikit_reader) {
    width: auto;
  }

  .permission {
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
      margin: 1rem 0;
    }
  }
}